import React, { Component } from 'react'
import { Row, Col, Input, Button, Spin, Modal, Cascader } from 'antd'
import Card from '../../components/Card'
import TeamSeleted from '../../components/TeamSeleted'
import FormModal from '../../components/FormModal2'
import default_img from '../../assets/head_default_img.png'
import { api, app, config } from "../../app"

const { TextArea } = Input

class TeamEditor extends Component {
    constructor (props) {
        super(props)
        this.state = {
            team_loading: true,
            team_info: {},
            info_loading: true,
            add_modal: false,
            all_team: [],
            select_team: {},
            provinceList: [],
            data_load_index: 0
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.ProviceData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 省份数据
     * @constructor
     */
    ProviceData = async () => {
        const params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.ProvinceCityList, params)
        if (flag === 1) {
            let provinceList = data.map((pro) => {
                return {
                    label: pro.area_name,
                    value: pro.area_name,
                    children: (pro.city || []).map((city) => {
                        return {
                            label: city.city_name,
                            value: city.city_id,
                        }
                    }),
                }
            })
            this.setData({ provinceList })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 添加队伍
     * @param e
     */
    handleAddTeam = async (values) => {
        if (this.state.add_loading) return false
        await this.setData({ add_loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        values.city_id = values.city_id[1];
        let { flag, msg } = await app.post(api.AddTeam, Object.assign(values, params)), state = { add_loading: false }
        if (flag === 1) {
            app.alert("创建成功", 'success')
            state.add_modal = false
            state.team_refresh = true
        } else {
            app.alert(msg, "warn")
        }
        await this.setData(state)
    }

    /**
     * 队伍数据
     * @param select_team
     * @param load_index
     */
    teamInfoData = async (select_team, load_index) => {
        await this.setData({ select_team, load_index, info_loading: true })
        let { flag, data, msg } = await app.post(api.AddteamInfo, { team_id: select_team.team_id })
        let state = {}
        if (flag === 1) {
            state.team_info = data
        } else {
            app.alert(msg, "error")
        }
        if (this.state.load_index === load_index) {
            state.info_loading = false
            await this.setData(state)
        }
    }

    /**
     * 显示添加对话框
     * @param add_modal
     */
    handleOpenAddModal = () => {
        this.setData({ add_modal: true })
    }

    /**
     * 隐藏添加对话框
     * @param add_modal
     */
    handleCloseAddModal = () => {
        this.setData({ add_modal: false })
    }

    /**
     * 跳转个人页面
     **/
    toPlayer = (team_id, indexno) => {
        this.history.go(`/player/${team_id}/${indexno}`)
    }

    /**
     * 打开注销对话框
     */
    handleOpenCancelModal = () => {
        this.setData({ cancel_modal: true })
    }

    /**
     * 关闭注销对话框
     * @param flag
     */
    handleCloseCancelModal = async (flag) => {
        let state = { cancel_modal: false }
        if (flag) {
            state.team_refresh = true
            await this.setData(state)
            let { select_team, load_index } = this.state
            await this.setData({ team_refresh: false })
            await this.teamInfoData(select_team, load_index)
        } else {
            await this.setData(state)
        }
    }

    /**
     * 提交注销信息
     **/
    handleSubmitCancel = ({ cancel_reason }) => {
        if (!cancel_reason) {
            app.alert("请输入注销原因", 'warn')
            return
        }
        Modal.confirm({
            title: '确定注销吗？',
            content: '',
            okText: '确定',
            cancelText: '取消',
            centered: true,
            onOk: async () => {
                await this.setData({ cancel_loading: true })
                let { select_team } = this.state, params = {
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                    teamno: select_team.teamno,
                    reason: cancel_reason,
                }, { flag, msg } = await app.post(api.UnderFrameTeam, params)
                await this.setData({ cancel_loading: false })
                if (flag === 1) {
                    app.alert("注销成功", 'success')
                    await this.handleCloseCancelModal(1)
                } else {
                    app.alert(msg, "warn")
                }
            }
        })
    }

    render () {
        let formItemLayout = {
                labelCol: { span: 4 },
                wrapperCol: { span: 19, offset: 1 },
            },
            { team_refresh, provinceList, select_team, add_modal, team_info, add_loading, cancel_loading, info_loading, cancel_modal } = this.state,
            teamheader = team_info.teamheader || [],
            administrator = team_info.administrator || []
        return (
            <div className="team-editor">
                <div className="top-title">队伍调配</div>
                <Row className="content">
                    <Col span={6} className="team-select">
                        <TeamSeleted refresh={team_refresh} handleData={this.teamInfoData} refreshLast={() => {
                            this.setData({ team_refresh: false })
                        }}/>
                    </Col>
                    <Col span={17} offset={1} className="team-info">
                        <Card width="100%" border={true}
                              style={{ padding: "20px 20px 0 20px", height: 'calc(100% - 68px)' }}
                              title={
                                  <Row type="flex" justify="space-between">
                                      <div>{select_team.teamname || "队伍名称"}</div>
                                      <div className="ti-actions">
                                          <Button className='tia-btn' type="primary"
                                                  onClick={() => this.handleOpenCancelModal()}>注销队伍</Button>
                                          {/*<Button className='' style={{margin: "0 20px"}} type="primary">合并队伍</Button>*/}
                                           <Button className='tia-btn' type="primary" onClick={this.handleOpenAddModal}>创建队伍</Button>
                                      </div>
                                  </Row>
                              }>
                            {
                                info_loading ?
                                    (<div className="data-loading"><Spin size="large"/></div>) :
                                    teamheader.length === 0 && administrator.length === 0 ? (
                                            <div className="data-loading">暂无记录</div>) :
                                        (
                                            <div className="info-top">
                                                <div className="it-item">
                                                    {
                                                        teamheader.map((tp, index) => (
                                                            <div key={index} className="it-img-info">
                                                                <div className="it-img">
                                                                    <img alt="加载失败"
                                                                         src={tp.localpath ? (config.imgUrl + app.urlEncode(tp.localpath)) : default_img}/>
                                                                </div>
                                                                <div className="it-info">
                                                                    <div className="zw">队长</div>
                                                                    <div className="name">{tp.vname}</div>
                                                                    <div className="bsrno">{tp.bsrno}</div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                <div className="it-item" hidden={administrator.length === 0}>
                                                    {
                                                        administrator.map((tp, index) => (
                                                            <div key={index} className="it-img-info">
                                                                <div className="it-img">
                                                                    <img alt="加载失败"
                                                                         src={tp.localpath ? (config.imgUrl + app.urlEncode(tp.localpath)) : default_img}/>
                                                                </div>
                                                                <div className="it-info">
                                                                    <div className="zw">管理员</div>
                                                                    <div className="name">{tp.vname}</div>
                                                                    <div className="bsrno">{tp.bsrno}</div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        )
                            }
                        </Card>
                        <div className="info-bottom">
                            <div className="info-bottom-title">队内统计信息</div>
                            <div className="info-bottom-content">
                                {/*<div className="list-item">*/}
                                {/*    <div className="li-left" span={12}>队内总人数</div>*/}
                                {/*    <div className="li-right" span={12}>{team_info.count || 0} 人</div>*/}
                                {/*</div>*/}
                                <div className="list-item">
                                    <div className="li-left" span={12}>队员</div>
                                    <div className="li-right" span={12}>{team_info.DYcount || 0} 人</div>
                                </div>
                                {/*<div className="list-item">*/}
                                {/*    <div className="li-left" span={12}>预备队员</div>*/}
                                {/*    <div className="li-right" span={12}>{team_info.YBDYcount || 0} 人</div>*/}
                                {/*</div>*/}
                                {/*<div className="list-item">*/}
                                {/*    <div className="li-left" span={12}>认证志愿者</div>*/}
                                {/*    <div className="li-right" span={12}>{team_info.ZYZcount || 0} 人</div>*/}
                                {/*</div>*/}
                                <div className="list-item">
                                    <div className="li-left" span={12}>认证人数</div>
                                    <div className="li-right" span={12}>{team_info.RZcount || 0} 人</div>
                                </div>
                                <div className="list-item">
                                    <div className="li-left" span={12}>离队人数</div>
                                    <div className="li-right" span={12}>{team_info.LDcount || 0} 人</div>
                                </div>
                                <div className="list-item">
                                    <div className="li-left" span={12}>清退人数</div>
                                    <div className="li-right" span={12}>{team_info.KCcount || 0} 人</div>
                                </div>
                                {/*<div className="list-item">*/}
                                {/*    <div className="li-left" span={12}>已合并队伍</div>*/}
                                {/*    <div className="li-right" span={12}> -</div>*/}
                                {/*</div>*/}
                                {/*<div className="list-item">*/}
                                {/*    <div className="li-left" span={12}>合并时间</div>*/}
                                {/*    <div className="li-right" span={12}> -</div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </Col>
                </Row>
                <FormModal
                    other={<p style={{ color: 'red' }}>注：队伍编码用于自动生成存心编号，统一设置为2位大写字母</p>}
                    onSubmit={this.handleAddTeam}
                    modal={{
                        visible: add_modal,
                        title: "创建队伍",
                        onCancel: this.handleCloseAddModal,
                        maskClosable: false,
                        destroyOnClose: true,
                        centered: true,
                        okText: '添加',
                        cancelText: '取消',
                        width: 620,
                        confirmLoading: add_loading,
                    }}
                    children={[
                        {
                            formItemLayout,
                            label: "城市",
                            name: "city_id",
                            options: {
                                rules: [
                                    { required: true, message: '请选择城市' },
                                ],
                            },
                            component: (
                                <Cascader options={provinceList} displayRender={(label) => label.join(' / ')}
                                          showSearch={true} placeholder="请选择城市" notFoundContent="无记录"/>
                            ),
                        },
                        {
                            formItemLayout,
                            label: "队伍名称",
                            name: "teamname",
                            options: {
                                rules: [
                                    { required: true, message: '请输入队伍名称' },
                                ],
                            },
                            component: (
                                <Input placeholder="请输入队伍名称"/>
                            ),
                        },
                        {
                            formItemLayout,
                            label: "队伍编号",
                            name: "team_code",
                            options: {
                                rules: [
                                    { required: true, message: '请输入队伍编号' },
                                ],
                            },
                            component: (
                                <Input placeholder="请输入队伍编号"/>
                            ),
                        }
                    ]}
                />
                <FormModal
                    other={<p style={{ color: 'red' }}>注销队伍前请确认队伍里面是否还有队员，全部队员离队后方可注销；注销后的队伍可以被搜索查看</p>}
                    onSubmit={this.handleSubmitCancel}
                    modal={{
                        visible: cancel_modal,
                        title: "注销队伍（" + select_team.teamname + "）",
                        onCancel: () => this.handleCloseCancelModal(0),
                        maskClosable: false,
                        destroyOnClose: true,
                        centered: true,
                        okText: '注销',
                        cancelText: '取消',
                        confirmLoading: cancel_loading,
                        okType: 'danger'
                    }}
                    children={[
                        {
                            formItemLayout,
                            label: "原因",
                            name: "cancel_reason",
                            options: [{
                                required: true, message: '请输入原因！',
                            }],
                            component: (
                                <TextArea placeholder="请输入原因" autosize={{ minRows: 4, maxRows: 8 }}/>
                            ),
                        }
                    ]}
                />
            </div>
        )
    }
}

export default TeamEditor



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamEditor.jsx